import { LookupType } from "@prisma/client";

import { Badge, MultiSelect, type MultiSelectProps, Select, type SelectProps } from "~/ui";

/** Explicit Shipping Options lookup type labels (do not rely on SO_/PO_ enum prefix formatting). */
const lookupTypeLabels: Record<string, string> = {
  SO_FREIGHT_TERMS: "Sales Order Freight Terms",
  PO_FREIGHT_TERMS: "Purchase Order Freight Terms",
  SO_SHIPPING_CARRIER: "Sales Order Shipping Carrier",
  SO_SHIPPING_FOB: "Sales Order Shipping FOB",
  SO_FREIGHT_METHOD: "Freight Method",
  BORDER_CROSSING_POINT: "Border Crossing Point",
  PORT_OF_ENTRY: "Port of Entry",
  BORDER_CROSSING_INSTRUCTION: "Border Crossing Instructions",
};

const typeToColors: Record<string, string> = {
  SO_FREIGHT_TERMS: "violet",
  PO_FREIGHT_TERMS: "blue",
  SO_SHIPPING_CARRIER: "green",
  SO_SHIPPING_FOB: "orange",
  SO_FREIGHT_METHOD: "cyan",
  BORDER_CROSSING_POINT: "grape",
  PORT_OF_ENTRY: "indigo",
  BORDER_CROSSING_INSTRUCTION: "teal",
};

const activeLookupTypes: LookupType[] = [
  LookupType.SO_FREIGHT_TERMS,
  LookupType.PO_FREIGHT_TERMS,
  LookupType.SO_SHIPPING_CARRIER,
  LookupType.SO_SHIPPING_FOB,
  LookupType.SO_FREIGHT_METHOD,
  LookupType.BORDER_CROSSING_POINT,
  LookupType.PORT_OF_ENTRY,
  LookupType.BORDER_CROSSING_INSTRUCTION,
];

const lookupTypeOptions = activeLookupTypes.map(type => ({
  value: type,
  label: lookupTypeLabels[type] ?? type,
}));

export const LookupTypeSelect = (props: Omit<SelectProps, "data">) => (
  <Select placeholder="Lookup Type" searchable clearable {...props} data={lookupTypeOptions} withinPortal />
);

export const LookupTypeMultiselect = (props: Omit<MultiSelectProps, "data">) => (
  <MultiSelect placeholder="Lookup Type" searchable clearable {...props} data={lookupTypeOptions} withinPortal />
);

type LookupTypeDisplayProps = {
  lookupType: LookupType | null;
};
export const LookupTypeDisplay = ({ lookupType }: LookupTypeDisplayProps) => {
  if (lookupType == null) {
    return <></>;
  }

  return (
    <Badge style={{ textTransform: "none" }} color={typeToColors[lookupType] ?? "gray"}>
      {lookupTypeToText(lookupType)}
    </Badge>
  );
};

export const lookupTypeToText = (lookupType: LookupType | string | null) =>
  lookupType == null ? "" : (lookupTypeLabels[lookupType] ?? lookupType);
